import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, TextField, Grid, Button } from '@material-ui/core';
import AppBarModal from '../../general/AppBarModal';
import { formulario, consulta, mostrarError } from '../../../global/js/funciones';
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';

class ConsultoriaEditarPeriodo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      periodo: '',
      cargando: false,
      cargandoPeriodo: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { modalEditarPeriodo, proceso } = this.props;
    if (modalEditarPeriodo && !prevProps.modalEditarPeriodo) {
      this.cargarPeriodo(proceso);
    }
    if (!modalEditarPeriodo && prevProps.modalEditarPeriodo) {
      this.setState({ periodo: '' });
    }
  }

  cargarPeriodo = (proceso) => {
    if (!proceso || !proceso.id) {
      this.setState({ periodo: '' });
      return;
    }
    this.setState({ cargandoPeriodo: true });
    consulta(`api/v1.0/consultoria/periodo/${proceso.id}`, null, null, (error, estado, resp) => {
      if (!error && estado === 200) {
        this.setState({ periodo: resp.periodo || '' });
      } else {
        this.setState({ periodo: proceso.periodo || '' });
      }
      this.setState({ cargandoPeriodo: false });
    });
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  }

  guardarPeriodo = () => {
    const { periodo } = this.state;
    const { proceso, actualizarMensaje, mostrarModalEditarPeriodo, onSaved } = this.props;

    if (!periodo || !periodo.toString().trim()) {
      actualizarMensaje({ titulo: 'El periodo no puede estar vacío', tipo: 'info', mostrar: true, tiempo: 6000 });
      return;
    }

    if (!proceso || !proceso.id) {
      actualizarMensaje({ titulo: 'No se pudo identificar la consultoría', tipo: 'error', mostrar: true, tiempo: 6000 });
      return;
    }

    const data = new FormData();
    data.append('periodo', periodo.toString().trim());

    this.setState({ cargando: true });
    actualizarMensaje({ titulo: 'Enviado datos, por favor espere...', tipo: 'info', mostrar: true, tiempo: 4000 });

    formulario(`api/v1.0/consultoria/${proceso.id}/actualizar-periodo`, data, 'put', (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.';
      let tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo || 'Periodo actualizado correctamente';
          mostrarModalEditarPeriodo(false);
          if (typeof onSaved === 'function') onSaved();
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
        }
      }
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
      this.setState({ cargando: false });
    });
  }

  render() {
    const { modalEditarPeriodo, mostrarModalEditarPeriodo } = this.props;
    const { periodo, cargando, cargandoPeriodo } = this.state;

    return (
      <Dialog fullWidth maxWidth="sm" open={modalEditarPeriodo} onClose={() => mostrarModalEditarPeriodo(false)}>
        <AppBarModal titulo="Editar Periodo de Consultoría" mostrarModal={() => mostrarModalEditarPeriodo(false)} titulo_accion="Cerrar" accion={() => mostrarModalEditarPeriodo(false)} />
        <DialogContent className="scroll">
          {cargandoPeriodo ? (
            <TareasTerminadas mensaje="Cargando periodo..." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  fullWidth
                  label="Periodo"
                  name="periodo"
                  value={periodo}
                  onChange={this.onChange}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => mostrarModalEditarPeriodo(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={this.guardarPeriodo} color="primary" variant="contained" disabled={cargando || cargandoPeriodo}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ConsultoriaEditarPeriodo.propTypes = {
  proceso: PropTypes.object,
  modalEditarPeriodo: PropTypes.bool.isRequired,
  mostrarModalEditarPeriodo: PropTypes.func.isRequired,
  actualizarMensaje: PropTypes.func.isRequired,
  onSaved: PropTypes.func,
};

ConsultoriaEditarPeriodo.defaultProps = {
  proceso: null,
  onSaved: null,
};

export default ConsultoriaEditarPeriodo;
